import type { JSX } from 'react';
import { HERO } from '../config/content';

import { Colonnade } from './Colonnade';
import { WaitlistForm } from './WaitlistForm';
import styles from './Hero.module.css';

/**
 * Copy on the left, the colonnade on the right, collapsing to one column on a narrow viewport.
 *
 * The copy comes first in the DOM as well as on screen, so the reading order a screen reader or
 * a keyboard follows matches the visual order at every width — and the decoration, which is
 * hidden from assistive technology anyway, is never in front of the thing the page is for.
 */
export function Hero(): JSX.Element {
  return (
    <div className={styles.hero}>
      <div className={styles.copy}>
        <div className={styles.grid} aria-hidden="true" />

        <div className={styles.inner}>
          <p className={styles.kicker}>{HERO.kicker}</p>
          <h1 className={styles.heading}>{HERO.heading}</h1>
          <p className={styles.lede}>{HERO.lede}</p>

          <WaitlistForm />
        </div>
      </div>

      <Colonnade />
    </div>
  );
}
